<template>
	<div>
		<div v-if="loading>0">
			<div class="text-center" v-if="loading>0">
				<b-icon icon="circle-fill" animation="throb" font-scale="4"></b-icon>
			</div>
		</div>
		<div v-else-if="user">
			<b-alert variant="danger" :show="!!error" class="mb-3">{{error}}</b-alert>
			<div class="mb-3">
				Email: {{user.email}} <b-button variant="primary" @click="$refs.emailModal.show()">Change</b-button> <b-button variant="secondary" v-if="!user.email_confirmed" @click="resendConfirmation()">Resend confirmation link</b-button>
			</div>
			<div class="mb-3">
				Username: {{user.username}} <b-button variant="primary" @click="$refs.usernameModal.show()">Change</b-button><br />
			</div>
			<div class="mb-3">
				<b-button variant="primary" @click="$refs.passwordModal.show()">Change password</b-button><br />
			</div>
			<div class="mb-3">
				<b-button variant="danger" @click="$refs.deleteModal.show()">Delete account</b-button><br />
			</div>
		</div>
		<div v-else>
			No userdata found.
		</div>
		<account-delete-modal ref="deleteModal"></account-delete-modal>
		<account-password-modal ref="passwordModal" @saved="loadUserData"></account-password-modal>
		<account-username-modal ref="usernameModal" @saved="loadUserData"></account-username-modal>
		<account-email-modal ref="emailModal" @saved="loadUserData"></account-email-modal>
	</div>
</template>

<script>
import AccountDeleteModal from '../../components/Account/Modal/Delete';
import AccountPasswordModal from '../../components/Account/Modal/Password';
import AccountUsernameModal from '../../components/Account/Modal/Username';
import AccountEmailModal from '../../components/Account/Modal/Email';

export default {
	components: {
		AccountDeleteModal,
		AccountPasswordModal,
		AccountUsernameModal,
		AccountEmailModal,
	},
	data: () => ({
		loading: 0,
		error: null,
		user: null,
	}),
	created() {
		this.loadUserData();
	},
	methods: {
		async loadUserData() {
			try {
				this.loading++;
				this.error = null;
				this.user = await this.$api.get('userData');
			} catch(err) {
				this.error = err;
			} finally {
				this.loading--;
			}
		},
		async resendConfirmation() {
			try {
				this.loading++;
				this.error = null;
				await this.$api.post('resendConfirmation', { email: this.user.email });
			} catch(err) {
				this.error = err;
			} finally {
				this.loading--;
			}
		},
	},
}
</script>
